import React, { useState, useEffect } from 'react';
import axios from 'axios';
import MerchantReviews from './MerchantReviews';
import './ShopInfoEdit.css';

function MerchantInfo() {
  const [merchant, setMerchant] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const fetchMerchantInfo = async () => {
    const tg = window.Telegram.WebApp;
    try {
      const res = await axios.get('/api/merchant/info', {
        headers: { 'x-telegram-init-data': tg.initData }
      });
      setMerchant(res.data);
      setError('');
    } catch (err) {
      console.error('获取商家信息失败', err);
      setError('加载失败，请稍后重试');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMerchantInfo();
  }, []);

  if (loading) return <div className="shop-info-edit-container" style={{ textAlign: 'center', padding: '40px' }}>加载中...</div>;
  if (error) return <div className="shop-info-edit-container" style={{ textAlign: 'center', padding: '40px', color: 'red' }}>{error}</div>;
  if (!merchant) return <div className="shop-info-edit-container" style={{ textAlign: 'center', padding: '40px' }}>暂无数据</div>;

  return (
    <div className="shop-info-edit-container">
      <h2>店铺信息</h2>
      <div className="merchant-info-grid">
        <div className="info-card">
          <div className="info-label">店铺名称</div>
          <div className="info-value">{merchant.name || '未设置'}</div>
        </div>
        <div className="info-card">
          <div className="info-label">描述</div>
          <div className="info-value">{merchant.description || '暂无描述'}</div>
        </div>
        <div className="info-card">
          <div className="info-label">详细地址</div>
          <div className="info-value">{merchant.address_text || '未设置'}</div>
        </div>
        <div className="info-card">
          <div className="info-label">地址备注</div>
          <div className="info-value">{merchant.address_note || '无'}</div>
        </div>
        <div className="info-card">
          <div className="info-label">显示地址</div>
          <div className="info-value">{merchant.address || '未设置'}</div>
        </div>
        <div className="info-card">
          <div className="info-label">Logo</div>
          <div className="info-value">
            {merchant.logo ? (
              <div className="logo-preview">
                <img src={merchant.logo} alt="Logo" style={{ maxWidth: '100px', maxHeight: '100px' }} />
                <a href={merchant.logo} target="_blank" rel="noopener noreferrer">查看原图</a>
              </div>
            ) : (
              <span>暂无Logo</span>
            )}
          </div>
        </div>
      </div>
      <hr />
      <h3>⭐ 顾客评价</h3>
      <MerchantReviews merchantId={merchant.id} />
    </div>
  );
}

export default MerchantInfo;